(function () {
  if (window.__scentellMobilePdpScriptV5) return;
  window.__scentellMobilePdpScriptV5 = true;
  const SELECTORS = {
    root: "[data-scentell-mobile-pdp]",
    track: "[data-smp-gallery-track]",
    slide: "[data-smp-gallery-slide]",
    dot: "[data-smp-gallery-dot]",
    thumb: "[data-smp-gallery-thumb]",
    prev: "[data-smp-gallery-prev]",
    next: "[data-smp-gallery-next]",
  };

  function formatMoney(cents, moneyFormat) {
    if (typeof cents === "string") cents = cents.replace(".", "");
    const value = Number(cents || 0);
    const amount = (value / 100).toFixed(2);
    if (!moneyFormat) return "$" + amount;
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      try {
        return window.Shopify.formatMoney(value, moneyFormat);
      } catch (e) {}
    }
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(value / 100));
  }

  function initGallery(scope) {
    const track = scope.querySelector(SELECTORS.track);
    if (!track) return;
    const slides = Array.from(scope.querySelectorAll(SELECTORS.slide));
    const dots = Array.from(scope.querySelectorAll(SELECTORS.dot));
    const thumbs = Array.from(scope.querySelectorAll(SELECTORS.thumb));
    const prev = scope.querySelector(SELECTORS.prev);
    const next = scope.querySelector(SELECTORS.next);
    let active = 0;

    const update = (index) => {
      active = Math.max(0, Math.min(slides.length - 1, index));
      dots.forEach((dot, i) => {
        const isActive = i === active;
        dot.classList.toggle("is-active", isActive);
        dot.classList.toggle("on", isActive);
      });
      thumbs.forEach((thumb, i) => {
        const isActive = i === active;
        thumb.classList.toggle("is-active", isActive);
        thumb.classList.toggle("on", isActive);
      });
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active === slides.length - 1;
    };

    const go = (index) => {
      const target = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: target * track.clientWidth, behavior: "smooth" });
      update(target);
    };

    track.addEventListener(
      "scroll",
      () => {
        if (!track.clientWidth) return;
        update(Math.round(track.scrollLeft / track.clientWidth));
      },
      { passive: true },
    );

    dots.forEach((dot, i) => dot.addEventListener("click", () => go(i)));
    thumbs.forEach((thumb, i) => thumb.addEventListener("click", () => go(i)));
    if (prev) prev.addEventListener("click", () => go(active - 1));
    if (next) next.addEventListener("click", () => go(active + 1));
    update(0);

    scope.smpGoToMedia = function (mediaId) {
      if (!mediaId) return;
      const index = slides.findIndex(
        (slide) => String(slide.dataset.mediaId) === String(mediaId),
      );
      if (index >= 0) go(index);
    };
  }

  function initScentCarousel(scope) {
    const track = scope.querySelector("[data-smp-scent-track]");
    if (!track) return;
    const slides = Array.from(track.querySelectorAll(".smp-scent-slide"));
    const dots = Array.from(scope.querySelectorAll("[data-smp-scent-dot]"));
    const prev = scope.querySelector("[data-smp-scent-prev]");
    const next = scope.querySelector("[data-smp-scent-next]");
    let active = 0;

    const getSlideLeft = (index) => {
      const slide = slides[index];
      if (!slide) return 0;
      return slide.offsetLeft - track.offsetLeft;
    };

    const getActiveFromScroll = () => {
      if (!slides.length) return 0;
      const left = track.scrollLeft;
      let closestIndex = 0;
      let closestDistance = Infinity;
      slides.forEach((slide, index) => {
        const distance = Math.abs(left - (slide.offsetLeft - track.offsetLeft));
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });
      return closestIndex;
    };

    const setActive = (index) => {
      active = Math.max(0, Math.min(slides.length - 1, index));
      dots.forEach((dot, i) => {
        const isActive = i === active;
        dot.classList.toggle("is-active", isActive);
        dot.classList.toggle("on", isActive);
      });
      if (prev) prev.disabled = active === 0;
      if (next) next.disabled = active >= slides.length - 1;
    };

    const go = (index) => {
      const target = Math.max(0, Math.min(slides.length - 1, index));
      track.scrollTo({ left: getSlideLeft(target), behavior: "smooth" });
      setActive(target);
    };

    const update = () => setActive(getActiveFromScroll());

    track.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update, { passive: true });
    dots.forEach((dot, i) => dot.addEventListener("click", () => go(i)));
    if (prev) prev.addEventListener("click", () => go(active - 1));
    if (next) next.addEventListener("click", () => go(active + 1));
    update();
  }

  function initScentsFaq(scope) {
    if (!scope || scope.dataset.smpScentsFaqReady === "true") return;

    const grid = scope.querySelector(".smp-scents-faq-grid");
    if (!grid) return;

    const getItems = () => Array.from(grid.querySelectorAll(".smp-scents-faq-item"));
    let items = getItems();
    if (!items.length) return;

    scope.dataset.smpScentsFaqReady = "true";

    items.forEach((item, index) => {
      if (!item.dataset.smpFaqOriginalIndex) {
        item.dataset.smpFaqOriginalIndex = String(index);
      }
    });

    const getOrderedItems = () => getItems().sort((a, b) => {
      return Number(a.dataset.smpFaqOriginalIndex || 0) - Number(b.dataset.smpFaqOriginalIndex || 0);
    });

    const getDirectColumns = () => Array.from(grid.children).filter((child) => {
      return child.classList && child.classList.contains("smp-scents-faq-col");
    });

    const restoreSingleColumn = () => {
      const orderedItems = getOrderedItems();
      orderedItems.forEach((item) => grid.appendChild(item));
      getDirectColumns().forEach((column) => column.remove());
      grid.classList.remove("is-columnized");
    };

    const ensureColumn = (modifier) => {
      const className = "smp-scents-faq-col--" + modifier;
      let column = Array.from(grid.children).find((child) => child.classList && child.classList.contains(className));
      if (!column) {
        column = document.createElement("div");
        column.className = "smp-scents-faq-col " + className;
      }
      return column;
    };

    const applyDesktopColumns = () => {
      const orderedItems = getOrderedItems();
      const leftColumn = ensureColumn("left");
      const rightColumn = ensureColumn("right");

      orderedItems.forEach((item, index) => {
        (index % 2 === 0 ? leftColumn : rightColumn).appendChild(item);
      });

      getDirectColumns().forEach((column) => {
        if (column !== leftColumn && column !== rightColumn) column.remove();
      });

      grid.appendChild(leftColumn);
      grid.appendChild(rightColumn);
      grid.classList.add("is-columnized");
    };

    const desktopQuery = window.matchMedia ? window.matchMedia("(min-width: 990px)") : null;
    const syncColumns = () => {
      if (desktopQuery && desktopQuery.matches) applyDesktopColumns();
      else restoreSingleColumn();
    };

    syncColumns();

    if (desktopQuery) {
      if (typeof desktopQuery.addEventListener === "function") {
        desktopQuery.addEventListener("change", syncColumns);
      } else if (typeof desktopQuery.addListener === "function") {
        desktopQuery.addListener(syncColumns);
      }
    } else {
      window.addEventListener("resize", syncColumns, { passive: true });
    }

    items = getOrderedItems();

    const prefersReducedMotion = window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const setExpanded = (item) => {
      const summary = item.querySelector("summary");
      if (summary) summary.setAttribute("aria-expanded", item.open ? "true" : "false");
    };

    const finish = (item, cleanup) => {
      window.setTimeout(() => {
        if (item.dataset.smpFaqAnimating !== "true") return;
        cleanup();
      }, 420);
    };

    items.forEach((item) => {
      if (item.dataset.smpFaqItemReady === "true") return;
      item.dataset.smpFaqItemReady = "true";

      const summary = item.querySelector("summary");
      if (!summary) return;
      summary.setAttribute("aria-expanded", item.open ? "true" : "false");

      summary.addEventListener("click", (event) => {
        if (prefersReducedMotion) {
          window.setTimeout(() => setExpanded(item), 0);
          return;
        }

        event.preventDefault();
        if (item.dataset.smpFaqAnimating === "true") return;

        const isOpen = item.open;
        item.dataset.smpFaqAnimating = "true";
        item.style.overflow = "hidden";

        const clearAnimation = () => {
          item.dataset.smpFaqAnimating = "false";
          item.classList.remove("is-closing");
          item.style.height = "";
          item.style.overflow = "";
          setExpanded(item);
        };

        if (isOpen) {
          item.classList.add("is-closing");
          const startHeight = item.offsetHeight;
          const endHeight = summary.offsetHeight;
          item.style.height = startHeight + "px";
          item.offsetHeight;
          item.style.height = endHeight + "px";
          summary.setAttribute("aria-expanded", "false");

          const onEnd = (transitionEvent) => {
            if (transitionEvent.target !== item || transitionEvent.propertyName !== "height") return;
            item.removeEventListener("transitionend", onEnd);
            item.removeAttribute("open");
            clearAnimation();
          };

          item.addEventListener("transitionend", onEnd);
          finish(item, () => {
            item.removeEventListener("transitionend", onEnd);
            item.removeAttribute("open");
            clearAnimation();
          });
          return;
        }

        item.setAttribute("open", "");
        summary.setAttribute("aria-expanded", "true");
        const startHeight = summary.offsetHeight;
        item.style.height = startHeight + "px";
        item.offsetHeight;
        item.style.height = item.scrollHeight + "px";

        const onEnd = (transitionEvent) => {
          if (transitionEvent.target !== item || transitionEvent.propertyName !== "height") return;
          item.removeEventListener("transitionend", onEnd);
          clearAnimation();
          item.style.height = "auto";
        };

        item.addEventListener("transitionend", onEnd);
        finish(item, () => {
          item.removeEventListener("transitionend", onEnd);
          clearAnimation();
          item.style.height = "auto";
        });
      });
    });
  }

  function initAccordions(scope) {
    if (!scope || scope.dataset.smpAccordionsReady === "true") return;
    scope.dataset.smpAccordionsReady = "true";

    const setOpen = (item, open) => {
      if (!item) return;
      item.classList.toggle("is-open", Boolean(open));
      const btn = item.querySelector("[data-smp-accordion-button], .acc-head");
      if (btn) btn.setAttribute("aria-expanded", open ? "true" : "false");
    };

    scope.querySelectorAll("[data-smp-accordion], .acc-item").forEach((item) => {
      const btn = item.querySelector("[data-smp-accordion-button], .acc-head");
      if (btn) btn.setAttribute("aria-expanded", item.classList.contains("is-open") ? "true" : "false");
    });

    scope.addEventListener(
      "click",
      (event) => {
        const button = event.target.closest("[data-smp-accordion-button], .acc-head");
        if (!button || !scope.contains(button)) return;

        event.preventDefault();
        event.stopPropagation();

        const item = button.closest("[data-smp-accordion], .acc-item");
        if (!item) return;

        const willOpen = !item.classList.contains("is-open");
        const wrap = item.parentElement;
        if (wrap) {
          wrap.querySelectorAll("[data-smp-accordion], .acc-item").forEach((sibling) => {
            if (sibling !== item) setOpen(sibling, false);
          });
        }

        setOpen(item, willOpen);
      },
      true,
    );
  }

  function getFirstAllocation(variant) {
    return variant &&
      variant.selling_plan_allocations &&
      variant.selling_plan_allocations.length
      ? variant.selling_plan_allocations[0]
      : null;
  }

  function initProduct(scope) {
    const jsonEl = scope.querySelector("[data-smp-product-json]");
    if (!jsonEl) return;

    let variants = [];
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    const moneyFormat = scope.dataset.moneyFormat;
    const form = scope.querySelector('form[action*="/cart/add"]');
    const variantInput = scope.querySelector("[data-smp-variant-id]");
    const sellingPlanInput = scope.querySelector("[data-smp-selling-plan]");
    const optionInputs = Array.from(
      scope.querySelectorAll("[data-smp-option-input]"),
    );
    const planButtons = Array.from(scope.querySelectorAll("[data-smp-plan]"));
    const formId = form ? form.id : "";
    let priceEls = formId
      ? Array.from(
          document.querySelectorAll(
            '[data-smp-current-price][data-product-form-id="' + formId + '"]',
          ),
        )
      : [];
    if (!priceEls.length)
      priceEls = Array.from(scope.querySelectorAll("[data-smp-current-price]"));
    const planLabelEls = formId
      ? Array.from(
          document.querySelectorAll(
            '[data-smp-plan-label][data-product-form-id="' + formId + '"]',
          ),
        )
      : [];
    const oneTimeEls = Array.from(
      scope.querySelectorAll("[data-smp-onetime-price]"),
    );
    const subPriceEls = Array.from(
      scope.querySelectorAll("[data-smp-sub-price]"),
    );
    const installmentEls = formId
      ? Array.from(
          document.querySelectorAll(
            '[data-smp-installment-price][data-product-form-id="' + formId + '"]',
          ),
        )
      : Array.from(scope.querySelectorAll("[data-smp-installment-price]"));
    const checkoutVariantInputs = formId
      ? Array.from(
          document.querySelectorAll(
            '[data-smp-checkout-variant-id][data-product-form-id="' + formId + '"]',
          ),
        )
      : Array.from(scope.querySelectorAll("[data-smp-checkout-variant-id]"));
    const checkoutSellingPlanInputs = formId
      ? Array.from(
          document.querySelectorAll(
            '[data-smp-checkout-selling-plan][data-product-form-id="' + formId + '"]',
          ),
        )
      : Array.from(scope.querySelectorAll("[data-smp-checkout-selling-plan]"));
    const dynamicCheckoutEls = formId
      ? Array.from(
          document.querySelectorAll(
            '[data-smp-dynamic-checkout][data-product-form-id="' + formId + '"]',
          ),
        )
      : Array.from(scope.querySelectorAll("[data-smp-dynamic-checkout]"));
    const checkoutForms = formId
      ? Array.from(
          document.querySelectorAll(
            '[data-smp-native-checkout-form][data-product-form-id="' + formId + '"]',
          ),
        )
      : Array.from(scope.querySelectorAll("[data-smp-native-checkout-form]"));
    let atcButtons = formId
      ? Array.from(
          document.querySelectorAll(
            '[data-smp-atc-button][data-product-form-id="' + formId + '"]',
          ),
        )
      : [];
    if (!atcButtons.length)
      atcButtons = Array.from(scope.querySelectorAll("[data-smp-atc-button]"));
    let currentPlan = scope.dataset.defaultPlan || "onetime";
    let currentVariant =
      variants.find(
        (variant) => variant.id === Number(variantInput && variantInput.value),
      ) || variants[0];

    function selectedOptions() {
      const optionCount = Number(scope.dataset.optionCount || 0);
      const selected = new Array(optionCount);
      optionInputs.forEach((input) => {
        if (input.checked)
          selected[Number(input.dataset.optionIndex)] = input.value;
      });
      return selected;
    }

    function findVariant() {
      const selected = selectedOptions();
      const match = variants.find((variant) => {
        return (
          variant.options &&
          variant.options.every(
            (value, index) => String(value) === String(selected[index]),
          )
        );
      });
      return match || currentVariant || variants[0];
    }

    function selectedPrice(variant) {
      const allocation = getFirstAllocation(variant);
      if (currentPlan === "sub" && allocation) return allocation.price;
      return variant ? variant.price : 0;
    }

    function getSelectedPlan() {
      const selectedButton = planButtons.find((button) => {
        return button.classList.contains("is-selected") || button.getAttribute("aria-pressed") === "true";
      });
      return (
        (selectedButton && selectedButton.dataset.smpPlan) ||
        scope.dataset.currentPlan ||
        currentPlan ||
        scope.dataset.defaultPlan ||
        "onetime"
      );
    }

    function syncSellingPlanInput() {
      if (scope.dataset.currentPlan) currentPlan = scope.dataset.currentPlan;
      currentPlan = getSelectedPlan();
      const allocation = getFirstAllocation(currentVariant);
      if (!allocation && currentPlan === "sub") currentPlan = "onetime";
      scope.dataset.currentPlan = currentPlan;

      const sellingPlanId =
        currentPlan === "sub" && allocation
          ? allocation.selling_plan_id ||
            (sellingPlanInput && sellingPlanInput.dataset.defaultSellingPlan) ||
            (checkoutSellingPlanInputs[0] && checkoutSellingPlanInputs[0].dataset.defaultSellingPlan) ||
            (sellingPlanInput && sellingPlanInput.value) ||
            ""
          : "";

      if (sellingPlanInput) {
        if (sellingPlanId) {
          sellingPlanInput.disabled = false;
          sellingPlanInput.removeAttribute("disabled");
          sellingPlanInput.name = "selling_plan";
          sellingPlanInput.value = sellingPlanId;
        } else {
          sellingPlanInput.value = "";
          sellingPlanInput.disabled = true;
          sellingPlanInput.setAttribute("disabled", "disabled");
        }
      }

      checkoutSellingPlanInputs.forEach((input) => {
        const previousValue = input.value;
        const previousDisabled = input.disabled;
        if (sellingPlanId) {
          input.disabled = false;
          input.removeAttribute("disabled");
          input.name = "selling_plan";
          input.value = sellingPlanId;
        } else {
          input.value = "";
          input.disabled = true;
          input.setAttribute("disabled", "disabled");
        }
        if (previousValue !== input.value || previousDisabled !== input.disabled) {
          input.dispatchEvent(new Event("change", { bubbles: true }));
        }
      });

      return sellingPlanId;
    }

    function updatePlanButtons() {
      const canSubscribe = Boolean(getFirstAllocation(currentVariant));
      if (scope.dataset.currentPlan) currentPlan = scope.dataset.currentPlan;
      if (!canSubscribe && currentPlan === "sub") currentPlan = "onetime";
      scope.dataset.currentPlan = currentPlan;
      planButtons.forEach((button) => {
        const isSelected = button.dataset.smpPlan === currentPlan;
        button.classList.toggle("is-selected", isSelected);
        button.setAttribute("aria-pressed", isSelected ? "true" : "false");
        const radio = button.querySelector(".sel-radio, .smp-sel-radio");
        if (radio) radio.classList.toggle("is-on", isSelected);
        if (button.dataset.smpPlan === "sub" && !canSubscribe) {
          button.setAttribute("disabled", "disabled");
          button.setAttribute("aria-disabled", "true");
        } else {
          button.removeAttribute("disabled");
          button.removeAttribute("aria-disabled");
        }
      });
      syncSellingPlanInput();
    }

    function updatePrice() {
      const currentPrice = selectedPrice(currentVariant);
      priceEls.forEach((el) => {
        el.textContent = formatMoney(currentPrice, moneyFormat);
      });
      oneTimeEls.forEach((el) => {
        el.textContent = formatMoney(
          currentVariant ? currentVariant.price : 0,
          moneyFormat,
        );
      });
      const allocation = getFirstAllocation(currentVariant);
      subPriceEls.forEach((el) => {
        el.textContent = allocation
          ? formatMoney(allocation.price, moneyFormat)
          : formatMoney(currentVariant ? currentVariant.price : 0, moneyFormat);
      });
      installmentEls.forEach((el) => {
        el.textContent = formatMoney(Math.round(currentPrice / 2), moneyFormat);
      });
    }

    function updateAtc() {
      const available = currentVariant && currentVariant.available;
      atcButtons.forEach((button) => {
        button.disabled = !available;
        const text = button.querySelector("[data-smp-atc-text]");
        if (text)
          text.textContent = available
            ? currentPlan === "sub"
              ? "Subscribe now!"
              : "Add to cart"
            : "Sold Out";
      });
    }

    function updateUrl() {
      if (!currentVariant || !window.history || !window.history.replaceState)
        return;
      const url = new URL(window.location.href);
      url.searchParams.set("variant", currentVariant.id);
      window.history.replaceState({}, "", url.toString());
    }

    function updateMedia() {
      if (
        currentVariant &&
        currentVariant.featured_media_id &&
        typeof scope.smpGoToMedia === "function"
      ) {
        scope.smpGoToMedia(currentVariant.featured_media_id);
      }
    }

    function applyVariant(nextVariant, shouldUpdateUrl) {
      currentVariant = nextVariant || findVariant();
      if (!currentVariant) return;
      if (variantInput) variantInput.value = currentVariant.id;
      updatePlanButtons();
      updatePrice();
      planLabelEls.forEach((el) => {
        el.textContent = currentPlan === "sub" ? "Subscribe" : "One-time";
      });
      updateAtc();
      updateMedia();
      if (shouldUpdateUrl) updateUrl();
    }

    optionInputs.forEach((input) => {
      input.addEventListener("change", () => applyVariant(findVariant(), true));
    });

    planButtons.forEach((button) => {
      button.addEventListener("click", () => {
        if (button.disabled) return;
        currentPlan = button.dataset.smpPlan || "onetime";
        scope.dataset.currentPlan = currentPlan;
        updatePlanButtons();
        updatePrice();
        planLabelEls.forEach((el) => {
          el.textContent = currentPlan === "sub" ? "Subscribe" : "One-time";
        });
        updateAtc();
      });
    });

    function syncSelectedPurchaseOption() {
      if (variantInput && currentVariant) variantInput.value = currentVariant.id;
      checkoutVariantInputs.forEach((input) => {
        if (currentVariant) {
          const nextValue = String(currentVariant.id);
          const previousValue = input.value;
          const previousDisabled = input.disabled;
          input.disabled = false;
          input.removeAttribute("disabled");
          input.value = nextValue;
          if (previousValue !== input.value || previousDisabled !== input.disabled) {
            input.dispatchEvent(new Event("change", { bubbles: true }));
          }
        }
      });
      return syncSellingPlanInput();
    }

    if (form) {
      form.addEventListener(
        "submit",
        () => {
          syncSelectedPurchaseOption();
        },
        true,
      );

      form.addEventListener("formdata", (event) => {
        const sellingPlanId = syncSelectedPurchaseOption();
        if (!event.formData) return;
        if (sellingPlanId) event.formData.set("selling_plan", sellingPlanId);
        else event.formData.delete("selling_plan");
      });

      atcButtons.forEach((button) => {
        button.addEventListener(
          "click",
          () => {
            syncSelectedPurchaseOption();
          },
          true,
        );
      });
    }

    dynamicCheckoutEls.forEach((el) => {
      ["pointerdown", "mousedown", "touchstart", "click"].forEach((eventName) => {
        el.addEventListener(
          eventName,
          () => {
            syncSelectedPurchaseOption();
          },
          true,
        );
      });
    });

    checkoutForms.forEach((checkoutForm) => {
      checkoutForm.addEventListener(
        "submit",
        () => {
          syncSelectedPurchaseOption();
        },
        true,
      );
      checkoutForm.addEventListener("formdata", (event) => {
        const sellingPlanId = syncSelectedPurchaseOption();
        if (!event.formData) return;
        if (currentVariant) event.formData.set("id", String(currentVariant.id));
        if (sellingPlanId) event.formData.set("selling_plan", sellingPlanId);
        else event.formData.delete("selling_plan");
      });
    });

    applyVariant(currentVariant, false);
    syncSelectedPurchaseOption();
  }

  function initDeliveryDates(scope) {
    const wrap = scope.querySelector("[data-smp-delivery]");
    if (!wrap) return;
    const fmt = new Intl.DateTimeFormat(undefined, {
      month: "short",
      day: "2-digit",
    });
    const addDays = (days) => {
      const date = new Date();
      date.setDate(date.getDate() + days);
      return fmt.format(date);
    };
    const ordered = addDays(0);
    const ready = addDays(1);
    const deliveredStart = addDays(3);
    const readyEnd = addDays(2);
    const deliveredEnd = addDays(4);
    wrap.querySelectorAll('[data-smp-date="ordered"]').forEach((el) => {
      el.textContent = ordered;
    });
    wrap.querySelectorAll('[data-smp-date="ready"]').forEach((el) => {
      el.textContent = ready;
    });
    wrap.querySelectorAll('[data-smp-date="delivered"]').forEach((el) => {
      el.textContent = deliveredStart + " - " + deliveredEnd;
    });
    wrap.querySelectorAll('[data-smp-date="header"]').forEach((el) => {
      el.textContent = deliveredStart + " and " + deliveredEnd;
    });
  }

  function initSticky(scope) {
    const form = scope.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    const bar = document.querySelector(
      '[data-smp-stickybar][data-product-form-id="' + form.id + '"]',
    );
    const button = scope.querySelector("[data-smp-main-atc]");
    if (!bar || !button) return;

    const update = () => {
      const rect = button.getBoundingClientRect();
      // Only show after the main PDP add-to-cart has been scrolled past.
      // Do not show while the CTA is still below the fold on first load.
      bar.classList.toggle("is-visible", rect.bottom <= 0);
    };
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function initUgcVideoControls(scope) {
    if (!scope || scope.dataset.smpUgcVideosReady === "true") return;

    const tiles = Array.from(scope.querySelectorAll(".smp-ugc-tile"));
    const videoTiles = tiles.filter((tile) => tile.querySelector("video.smp-ugc-video"));
    if (!videoTiles.length) return;

    scope.dataset.smpUgcVideosReady = "true";

    const setButtonState = (tile, isPlaying) => {
      tile.classList.toggle("is-video-playing", Boolean(isPlaying));
      tile.querySelectorAll("[data-smp-ugc-toggle]").forEach((button) => {
        button.classList.toggle("is-playing", Boolean(isPlaying));
        button.setAttribute("aria-label", isPlaying ? "Pause video" : "Play video");
        button.setAttribute("aria-pressed", isPlaying ? "true" : "false");
      });
    };

    const pauseOtherVideos = (currentVideo) => {
      videoTiles.forEach((tile) => {
        const video = tile.querySelector("video.smp-ugc-video");
        if (!video || video === currentVideo) return;
        if (!video.paused) video.pause();
        setButtonState(tile, false);
      });
    };

    videoTiles.forEach((tile) => {
      if (tile.dataset.smpUgcVideoReady === "true") return;
      tile.dataset.smpUgcVideoReady = "true";

      const video = tile.querySelector("video.smp-ugc-video");
      if (!video) return;

      video.playsInline = true;
      video.removeAttribute("controls");
      video.pause();
      setButtonState(tile, false);

      tile.querySelectorAll("[data-smp-ugc-toggle]").forEach((button) => {
        button.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (video.paused || video.ended) {
            pauseOtherVideos(video);
            console.log('muted at click:', video.muted, 'volume:', video.volume);
            const playResult = video.play();
            if (playResult && typeof playResult.catch === "function") {
              playResult
                .then(() => setButtonState(tile, true))
                .catch(() => setButtonState(tile, false));
            } else {
              setButtonState(tile, true);
            }
            return;
          }

          video.pause();
          setButtonState(tile, false);
        });
      });

      video.addEventListener("play", () => {
        pauseOtherVideos(video);
        setButtonState(tile, true);
      });
      video.addEventListener("pause", () => setButtonState(tile, false));
      video.addEventListener("ended", () => setButtonState(tile, false));
    });
  }

  function initMoreReviews(scope) {
    scope.querySelectorAll("[data-smp-more-reviews]").forEach((wrap) => {
      const btn = wrap.querySelector("[data-smp-read-more]");
      if (!btn) return;
      btn.addEventListener("click", () => wrap.classList.add("is-expanded"));
    });
  }

  function initAnimations() {
    const items = document.querySelectorAll(".smp-animate");
    if (!items.length) return;
    if (!("IntersectionObserver" in window)) {
      items.forEach((item) => item.classList.add("is-visible"));
      return;
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12 },
    );
    items.forEach((item) => observer.observe(item));
  }


  function cleanupNativeSubscriptionWidgets(scope) {
    const selectors = [
      ".shopify_subscriptions_app_block",
      ".shopify-subscriptions-app-block",
      ".shopify_subscriptions_purchase_options_wrapper",
      ".shopify_subscriptions_fieldset",
      ".shopify_subscriptions_app_policy",
      "shopify-subscriptions-root",
      "shopify-subscriptions-selector",
      "selling-plan-selector",
      ".selling-plan-selector",
      ".selling-plan-fieldset",
      ".shopify-selling-plans",
      ".shopify-selling-plan-groups",
      ".product-form__subscription",
      ".product-form__selling-plan",
      ".product-form__purchase-options",
    ];

    const hide = () => {
      selectors.forEach((selector) => {
        scope.querySelectorAll(selector).forEach((el) => {
          if (!el.closest(".subw")) el.style.setProperty("display", "none", "important");
        });
      });

      const form = scope.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      Array.from(form.children).forEach((child) => {
        if (child.matches(".subw") || child.querySelector("[data-smp-plan]") || child.querySelector("[data-smp-atc-button]")) return;
        const text = (child.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
        const looksLikeNativePlanWidget =
          text.includes("choose your plan") ||
          (text.includes("one-time purchase") && (text.includes("subscribe") || text.includes("selling plan")));
        if (looksLikeNativePlanWidget) child.style.setProperty("display", "none", "important");
      });
    };

    hide();
    const observer = new MutationObserver(hide);
    observer.observe(scope, { childList: true, subtree: true });
  }

  function initCartButton(scope) {
    scope.querySelectorAll("[data-smp-open-cart]").forEach((button) => {
      button.addEventListener("click", () => {
        const drawer = document.querySelector("cart-drawer");
        if (drawer && typeof drawer.open === "function") {
          drawer.open();
          return;
        }
        const cartIcon = document.querySelector("#cart-icon-bubble, a[href*=\"/cart\"]");
        if (cartIcon && typeof cartIcon.click === "function") cartIcon.click();
        else window.location.href = "/cart";
      });
    });
  }

  function init() {
    if (document.body) document.body.classList.add("scentell-mobile-pdp-active");
    document.querySelectorAll(SELECTORS.root).forEach((scope) => {
      cleanupNativeSubscriptionWidgets(scope);
      initGallery(scope);
      initProduct(scope);
      initAccordions(scope);
      initDeliveryDates(scope);
      initSticky(scope);
      initCartButton(scope);
    });
    document.querySelectorAll(".scentell-mobile-pdp-shell").forEach((scope) => {
      initScentCarousel(scope);
      initScentsFaq(scope);
      initUgcVideoControls(scope);
      initMoreReviews(scope);
    });
    initAnimations();
  }

  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", init);
  else init();
})();

/* v6 direct gallery switch fallback. This intentionally avoids track.scrollTo because
   some Shopify/theme environments keep the thumb state but do not move the hero slide. */
(function () {
  function initDirectGallery(root) {
    if (!root || root.dataset.directGalleryV6 === "true") return;
    root.dataset.directGalleryV6 = "true";

    root.querySelectorAll(".mp-status, .gal-dots, .smp-gallery-dots, [data-smp-gallery-dot]").forEach(function (el) {
      el.remove();
    });

    var gallery = root.querySelector("[data-smp-gallery]");
    if (!gallery) return;
    var track = gallery.querySelector("[data-smp-gallery-track]");
    var slides = Array.prototype.slice.call(gallery.querySelectorAll("[data-smp-gallery-slide]"));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-smp-gallery-thumb]"));
    var prev = gallery.querySelector("[data-smp-gallery-prev]");
    var next = gallery.querySelector("[data-smp-gallery-next]");
    var index = 0;

    if (track) track.classList.add("smp-direct-gallery");

    function clamp(value) {
      if (!slides.length) return 0;
      return Math.max(0, Math.min(Number(value) || 0, slides.length - 1));
    }

    function render() {
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle("is-active", active);
        slide.setAttribute("aria-hidden", active ? "false" : "true");
      });
      thumbs.forEach(function (thumb, i) {
        var active = i === index;
        thumb.classList.toggle("is-active", active);
        thumb.classList.toggle("on", active);
        thumb.setAttribute("aria-current", active ? "true" : "false");
      });
      if (prev) prev.disabled = slides.length <= 1;
      if (next) next.disabled = slides.length <= 1;
    }

    function go(value) {
      index = clamp(value);
      render();
    }

    gallery.addEventListener(
      "click",
      function (event) {
        var thumb = event.target.closest("[data-smp-gallery-thumb]");
        var prevBtn = event.target.closest("[data-smp-gallery-prev]");
        var nextBtn = event.target.closest("[data-smp-gallery-next]");
        if (!thumb && !prevBtn && !nextBtn) return;

        event.preventDefault();
        event.stopPropagation();
        if (event.stopImmediatePropagation) event.stopImmediatePropagation();

        if (thumb) {
          var thumbIndex = thumbs.indexOf(thumb);
          if (thumbIndex > -1) go(thumbIndex);
        } else if (prevBtn) {
          go(index - 1);
        } else if (nextBtn) {
          go(index + 1);
        }
      },
      true,
    );

    root.smpGoToMedia = function (mediaId) {
      if (!mediaId) return;
      var mediaIndex = slides.findIndex(function (slide) {
        return String(slide.dataset.mediaId || "") === String(mediaId);
      });
      if (mediaIndex > -1) go(mediaIndex);
    };

    render();
  }

  function init() {
    document.querySelectorAll("[data-scentell-mobile-pdp]").forEach(initDirectGallery);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
